var _circle, _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMalaysia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m244.87 256h267.13c0-23.107-3.08-45.489-8.819-66.783h-258.311z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.87 122.435h229.556c-15.671-25.572-35.706-48.175-59.069-66.783h-170.487z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 512c60.249 0 115.626-20.824 159.357-55.652h-318.714c43.731 34.828 99.108 55.652 159.357 55.652z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.574 389.565h436.852c12.581-20.528 22.337-42.969 28.755-66.783h-494.362c6.417 23.814 16.174 46.255 28.755 66.783z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 256c0-141.384 0-158.052 0-256-141.384 0-256 114.616-256 256z",
    fill: "#0052b4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m170.234 219.13c-34.962 0-63.304-28.343-63.304-63.304s28.343-63.304 63.304-63.304c10.901 0 21.158 2.757 30.113 7.609-14.048-13.737-33.26-22.217-54.461-22.217-43.029 0-77.913 34.883-77.913 77.913s34.884 77.913 77.913 77.913c21.201 0 40.413-8.48 54.461-22.217-8.955 4.85-19.211 7.607-30.113 7.607z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.073 111.304 11.239 23.502 25.381-5.864-11.366 23.439 20.412 16.187-25.414 5.729.071 26.051-20.323-16.298-20.324 16.298.07-26.051-25.414-5.729 20.412-16.187-11.367-23.439 25.383 5.864z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/malaysia.08d04978a34152de05ebe8132e07cfe2.svg";
export { ForwardRef as ReactComponent };